import angular from 'angular';

class PaymentSvc {
    /* @ngInject */
    constructor(PaymentDA) {
        this.PaymentDA = PaymentDA;
    }

    /**
     * Recherche des sessions de paiement
     */
    searchPayments(value) {
        return this.PaymentDA.searchPayments(value);
    }

    searchBeneficiaries(value) {
        return this.PaymentDA.searchBeneficiaries(value);
    }
}

angular.module('app.payment').service('PaymentSvc', PaymentSvc);
